/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMCPRegistriesRequest,
  ListMCPRegistriesSecurity,
} from "../models/operations/listmcpregistries.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListMCPRegistriesQuery,
  ListMCPRegistriesQueryData,
  prefetchListMCPRegistries,
  queryKeyListMCPRegistries,
} from "./listMCPRegistries.core.js";
export {
  buildListMCPRegistriesQuery,
  type ListMCPRegistriesQueryData,
  prefetchListMCPRegistries,
  queryKeyListMCPRegistries,
};

export type ListMCPRegistriesQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listRegistries mcpRegistries
 *
 * @remarks
 * List all MCP registries (admin only)
 */
export function useListMCPRegistries(
  request?: ListMCPRegistriesRequest | undefined,
  security?: ListMCPRegistriesSecurity | undefined,
  options?: QueryHookOptions<
    ListMCPRegistriesQueryData,
    ListMCPRegistriesQueryError
  >,
): UseQueryResult<ListMCPRegistriesQueryData, ListMCPRegistriesQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildListMCPRegistriesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listRegistries mcpRegistries
 *
 * @remarks
 * List all MCP registries (admin only)
 */
export function useListMCPRegistriesSuspense(
  request?: ListMCPRegistriesRequest | undefined,
  security?: ListMCPRegistriesSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListMCPRegistriesQueryData,
    ListMCPRegistriesQueryError
  >,
): UseSuspenseQueryResult<
  ListMCPRegistriesQueryData,
  ListMCPRegistriesQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListMCPRegistriesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListMCPRegistriesData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: ListMCPRegistriesQueryData,
): ListMCPRegistriesQueryData | undefined {
  const key = queryKeyListMCPRegistries(...queryKeyBase);

  return client.setQueryData<ListMCPRegistriesQueryData>(key, data);
}

export function invalidateListMCPRegistries(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "mcpRegistries",
      "listRegistries",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllListMCPRegistries(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpRegistries", "listRegistries"],
  });
}
